module.exports = __webpack_public_path__ + "static/media/logo.f2e2040f.svg";